export default {
  billingLoaded(state) {
    return state.billingLoaded;
  },
  invoicesLoaded(state) {
    return state.invoicesLoaded;
  },
  billingID(state) {
    return state.customerId;
  },
  nextBillingPeriod(state) {
    var nextDate = new Date(
      Number(state.nextBillingAt) * 1000
    ).toLocaleDateString();
    return nextDate;
  },
  customerBalance(state) {
    var customerBalance =
      state.currencySymbol +
      parseFloat(state.unbilledCharges / 100).toFixed(2) +
      " " +
      state.currencyCode;
    return customerBalance;
  },
  currencyCode(state) {
    return state.currencyCode;
  },
  accountLocked(state) {
    return state.accountLocked;
  },
  subscriptionStatus(state) {
    return state.status;
  },
  outstandingCharges(state) {
    if (state.unpaidCharges && state.unpaidCharges.dueInvoiceCount > 0) {
      return true;
    } else {
      return false;
    }
  },
  currencySymbol(state) {
    return state.currencySymbol;
  },
  unpaidCharges(state) {
    var dueSince = null;
    if (state.unpaidCharges.dueSince) {
      dueSince = new Date(
        Number(state.unpaidCharges.dueSince) * 1000
      ).toLocaleDateString();
    }
    var totalDues =
      state.currencySymbol +
      parseFloat(state.unpaidCharges.totalDues / 100).toFixed(2) +
      " " +
      state.currencyCode;
    var data = {
      dueInvoiceCount: state.unpaidCharges.dueInvoiceCount,
      dueSince: dueSince,
      totalDue: totalDues,
    };
    return data;
  },
  storedCard(state) {
    return state.storedCard;
  },
  billingAddress(state) {
    return state.billingAddress;
  },
  invoiceData(state) {
    return state.invoiceData;
  },
  paymentMethod(state) {
    if (state.paymentMethod == "card") {
      return (
        state.storedCard.cardType.charAt(0).toUpperCase() +
        state.storedCard.cardType.slice(1) +
        " Ending in " +
        state.storedCard.last4
      );
    } else {
      return "No payment method";
    }
  },
  productData(state) {
    return state.products;
  },
};
